import { render, staticRenderFns } from "./CampaignsIcon.vue?vue&type=template&id=6e8e17ec&"
import script from "./CampaignsIcon.vue?vue&type=script&lang=js&"
export * from "./CampaignsIcon.vue?vue&type=script&lang=js&"
import style0 from "./CampaignsIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
